// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","966":"dashboard"}[chunkId] + "." + {"177":"1f5502a8","966":"d52e0a98"}[chunkId] + ".css";
};